import { Component, EventEmitter, Input, Output } from '@angular/core';

import { extractFiles } from '../../utils';

/**
 * # Media input component
 *
 * How to use it
 *
 * @Output load: File[]
 *
 * Example
 *
 * ```typescript
 * <app-media-input (load)="loadHandler($event)"></app-media-input>
 * ```
 */
@Component({
  selector: 'app-media-input',
  styleUrls: ['./media-input.component.scss'],
  templateUrl: './media-input.component.html',
})
export class MediaInputComponent {

  isDropping = false;

  @Input() label = 'Carica media';
  @Input() disabled = false;

  // tslint:disable-next-line:no-output-native
  @Output() readonly load = new EventEmitter<File[]>();

  constructor() { }

  dropHandler(ev: DragEvent) {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer) {
      this.emitLoadFiles(ev.dataTransfer.files);
    }

    this.isDropping = false;
  }

  dragOverHandler(ev: Event) {
    ev.preventDefault();

    this.isDropping = true;
  }

  // tslint:disable-next-line:variable-name
  dragLeaveHandler(_ev: Event) {
    this.isDropping = false;
  }

  onFileChange(ev: Event) {
    const element = ev.target as HTMLInputElement;

    if (element.files) {
      this.emitLoadFiles(element.files);
    }
  }

  private emitLoadFiles(fileList: FileList) {
    const files = extractFiles(fileList);
    this.load.emit(files);
  }
}
